import axiosConfig from 'config/axiosConfig';
import UrlImage from 'config/UrlImage';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function ListTutorial(props) {

    const [category, setCategory] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ListTutorial, setListTutorial] = useState([]);

    const [searchInput, setSearchInput] = useState('')
    const [filteredResults, setFilteredResults] = useState([])

    const [currentPage] = useState(1)
    const [itemsPerPage, setitemsPerPage] = useState(4);

    useEffect(() => {
        const category_slug = props.match.params.slug

        const fetchPosts = async () => {
            setLoading(true)
            const res = await axiosConfig.get(`/api/category-tutorial/${category_slug}`)
            setListTutorial(res.data.list_tutorial.listTutorial)
            setCategory(res.data.list_tutorial.category)
            setLoading(false)
        }
        fetchPosts()
    }, [props.match.params.slug]);

    const searchItems = (searchValue) => {
        setSearchInput(searchValue)
        if (searchInput !== '') {
            const filteredData = ListTutorial.filter((item) => {
                return item.title.toLowerCase().includes(searchInput.toLowerCase())
            })
            setFilteredResults(filteredData)
        } else {
            setFilteredResults(ListTutorial)
        }
    }

    const pages = []
    for (let i = 1; i <= Math.ceil(ListTutorial.length / itemsPerPage); i++) {
        pages.push(i)
    }

    const indexOfLastItem = currentPage * itemsPerPage
    const indexOfFirstItem = indexOfLastItem - itemsPerPage
    const currentItems = ListTutorial.slice(indexOfFirstItem, indexOfLastItem)

    const handleLoadMore = () => {
        setitemsPerPage(itemsPerPage + 2)
    }

    const renderData = ListTutorial => {
        const tutorialCount = ListTutorial.length

        if (loading) {
            return (
                <div className="col-md-12 py-5 px-5 text-center">
                    <div className="spinner-grow" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>
            )
        } else {
            if (tutorialCount < 1) {
                return (
                    <div className="col-md-12 py-5 px-5 text-center">
                        <h4>Belum ada Tutorial yang di upload untuk kategori <strong>{category.name}</strong></h4>
                    </div>
                )
            } else {
                return (
                    <>
                        {ListTutorial.map((item) => {
                            return (
                                <div className="col-12 mt-4 col-md-4 col-lg-3">
                                    <div className="card" key={item.index}>
                                        <div className="card-body">
                                            <Link to="/detail" className="component-content d-block">
                                                <div className="content-thumbnail">
                                                    <div className="content-image">
                                                        <Link to={`/tutorial/read/${item.slug}`}>
                                                            <img src={`${UrlImage}/${item.image}`} alt='i' className="img-fluid" />
                                                        </Link>
                                                    </div>
                                                </div>
                                                <div className="content-title">
                                                    <Link to={`/tutorial/read/${item.slug}`}>
                                                        {item.title}
                                                    </Link>
                                                </div>
                                            </Link>
                                            <div className="divider"></div>
                                            <div className="author">
                                                <div className="author-profile">
                                                    <small className="mt-2">
                                                        <div className='text-info'><h5>{category.name}</h5></div>
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}

                        <div className="container row my-6 mx-6">
                            <button className="btn btn-outline-info btn-sm mt-2 mb-4" onClick={handleLoadMore}>Load More</button>
                        </div>
                    </>
                )
            }
        }
    }

    return (
        <div className="details-header">
            <div className="container my-2">
                <input
                    type="text"
                    className="form-control"
                    onChange={(e) => searchItems(e.target.value)}
                    placeholder="Cari Tutorial..."
                />
                {searchInput.length > 1 ? (
                    filteredResults.map((item) => {
                        return (
                            <div className='my-2 mx-0   '>
                                    <Link to="" className="nav-link text-info">{item.title}</Link>
                                
                            </div>
                        )
                    })
                ) : (
                    <></>
                )}
                <div className="row">
                    {renderData(currentItems)}
                </div>
            </div>
        </div>
    );
}

export default ListTutorial;
